import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PageScroll } from '@/layouts/page-layout';
import { LayoutTemplateIcon } from 'lucide-react';
import LandingsHubSection from './hub-section';

export default function LandingsPage() {
	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-3'>
			<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
				<CardHeader className='border-b px-4 py-4 flex'>
					<div className='flex items-center gap-3'>
						<div className='rounded-lg bg-chart-4/15 p-2'>
							<LayoutTemplateIcon className='text-chart-4' size={20} />
						</div>
						<div>
							<CardTitle className='text-chart-4'>Лендинги</CardTitle>
							<CardDescription>Домены, сайты, ссылки и статистика</CardDescription>
						</div>
					</div>
				</CardHeader>
				<CardContent className='px-4 py-4'>
					<LandingsHubSection />
				</CardContent>
			</Card>
		</PageScroll>
	);
}
